"use client";
import UserPlusIcon from "@heroicons/react/24/outline/UserPlusIcon";
import AvatarDecoration from "@/components/views/avatar-decoration/AvatarDecoration";
import CreateWorkerProfileModal from "@/components/views/modals/create-profile";
import { useState } from "react";

export default function AddProfileCard() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <button
        role="button"
        onClick={() => setModalIsOpen(true)}
        className="cursor-pointer lg:w-[389px] w-full h-[124px] p-4 rounded-3xl border border-teal-500 justify-start items-center gap-2 inline-flex"
      >
        <AvatarDecoration className="rounded-[27.60px]">
          <div className="flex justify-center items-center w-[92px] h-[92px] bg-teal-500 rounded-[27.60px] shadow border border-white border-opacity-30">
            <UserPlusIcon className="text-white size-6" />
          </div>
        </AvatarDecoration>

        <div className="flex items-start flex-col gap-2">
          <span className="text-slate-800 text-base font-bold font-['DM Sans']">
            Sen de Profil Oluştur
          </span>

          <span className="text-gray-400 text-xs font-medium font-['DM Sans']">
            Ücretsiz Hesap Oluştur
          </span>
        </div>
      </button>

      <CreateWorkerProfileModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
    </>
  );
}
